import { ControlButton } from "@/components/atoms/control-button";
import {
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
} from "lucide-react";

interface MazeControlsProps {
  readonly inputDisabled?: boolean;
  readonly highlightControls?: boolean;
  readonly isVisible?: boolean;
}

export function MazeControls({
  inputDisabled = false,
  highlightControls = false,
  isVisible = true,
}: MazeControlsProps) {
  return (
    <div
      className="mt-1 flex flex-col items-center gap-2"
      style={{
        visibility: isVisible ? 'visible' : 'hidden',
        pointerEvents: isVisible ? 'auto' : 'none',
      }}
      aria-hidden={!isVisible}
    >
      <div className="grid grid-cols-3 gap-2" data-tutorial-controls>
        <div />
        <ControlButton
          direction="UP"
          icon={<ChevronUp size={26} />}
          isDisabled={inputDisabled}
          isHighlighted={highlightControls}
        />
        <div />
        <ControlButton
          direction="LEFT"
          icon={<ChevronLeft size={26} />}
          isDisabled={inputDisabled}
          isHighlighted={highlightControls}
        />
        <ControlButton
          direction="DOWN"
          icon={<ChevronDown size={26} />}
          isDisabled={inputDisabled}
          isHighlighted={highlightControls}
        />
        <ControlButton
          direction="RIGHT"
          icon={<ChevronRight size={26} />}
          isDisabled={inputDisabled}
          isHighlighted={highlightControls}
        />
      </div>
    </div>
  );
}
